import { UseFormReset } from "react-hook-form";
import { HTTP_STATUSES } from "@miplatform/constants";
import { simpleSort } from "@miplatform/utils";
import { useMaterials } from "@mibuildweb/hooks";
import { IItemData, ILinkedMaterial } from "../Items.types";

export const useAddItemViewModel = ({
  reset,
  goBack,
}: IUseAddItemViewModelProps) => {
  const {
    isLoading,
    getMaterials,
    getMaterialDetails,
    createMaterial,
    updateMaterial,
  } = useMaterials();

  const fetchItemDetails = async (id: string) => {
    const { status, data } = await getMaterialDetails(id);
    if (status === HTTP_STATUSES.OK) {
      const linkedMaterialIds = data.linkedMaterials.map(
        (l: ILinkedMaterial) => l.materialId
      );
      const linkedMaterialDetails = await getMaterials({
        filters: { id: { in: linkedMaterialIds } },
      });
      const updatedLinkedMaterials = data.linkedMaterials
        .map((linkedMaterial: ILinkedMaterial) => {
          const itemData = linkedMaterialDetails.data.find(
            (item: ILinkedMaterial) => item.id === linkedMaterial.materialId
          );
          return { ...linkedMaterial, ...itemData };
        })
        .sort((a: IItemData, b: IItemData) =>
          simpleSort(a.materialItemCode, b.materialItemCode)
        );
      data.linkedMaterials = updatedLinkedMaterials;
      reset(data);
    }
  };

  const handleCreateItem = async (data: IItemData) => {
    const modifiedData = {
      ...data,
      attributes: data.attributes.filter((attribute) => attribute.value),
    };
    const response = await createMaterial(modifiedData);
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  const handleUpdateItem = async (data: IItemData) => {
    const modifiedData = {
      ...data,
      attributes: data.attributes.filter((attribute) => attribute.value),
    };
    const response = await updateMaterial(modifiedData);
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  return {
    isLoading,
    fetchItemDetails,
    handleCreateItem,
    handleUpdateItem,
  };
};

interface IUseAddItemViewModelProps {
  reset: UseFormReset<IItemData>;
  goBack: () => void;
}
